import { generateId } from '@freelancer/datastore/testing/helpers';
import { CanvasContextTypeApi } from 'api-typings/canvas/canvas';
import type { Canvas } from './canvas.model';

export interface GenerateCanvasOptions {
  readonly contextId: number;
  readonly contextType: CanvasContextTypeApi;
  readonly createdBy?: number;
  readonly createdAt?: number;
  readonly title?: string;
}

export function generateCanvasObject({
  contextId = generateId(),
  contextType = CanvasContextTypeApi.THREAD,
  createdBy,
  createdAt = Date.now(),
  title,
}: GenerateCanvasOptions): Canvas {
  return {
    id: generateId(),
    contextId,
    contextType,
    createdBy,
    createdAt,
    title,
  };
}
